import loadable from '@loadable/component';

export const FlashMessageLoadable = loadable(() => import('./FlashMessage'), {
  resolveComponent: (module) => module.FlashMessage,
});
